import Task from '@/classes/task/Task';
import { TaskResponse } from '@/classes/task/types';
import { HttpMethod } from '@/types/HttpMethods';
import { pretension } from '@/utils/config';
import { CreatePretensionData, UpdatePretensionData } from './types';

interface PretensionListOptions {
  suppliers?: Array<string>;
  createdAt?: Array<string>;
  platformId?: string;
  type?: string;
  status: string;
  pageFrom: number;
  pageSize: number;
}

class PretensionController {
  public static async update(data: UpdatePretensionData): Promise<TaskResponse> {
    const url = pretension.update;
    const result = await Task.execute({ url, method: HttpMethod.PUT, body: data });
    return result;
  }

  public static async create(data: CreatePretensionData): Promise<TaskResponse> {
    const url = pretension.create;
    const result = await Task.execute({ url, method: HttpMethod.POST, body: data });
    return result;
  }

  public static async single(id: number): Promise<TaskResponse> {
    const url = `${pretension.single}?id=${id}`;
    const result = await Task.execute({ url, method: HttpMethod.GET });
    return result;
  }

  public static async list(options: PretensionListOptions): Promise<TaskResponse> {
    let url = pretension.list;
    const query: Array<{ key: string; value: string | null | undefined }> = [];
    query.push({ key: 'suppliers', value: options.suppliers?.join(',') });
    query.push({ key: 'createdAt', value: options.createdAt?.join(',') });
    query.push({ key: 'platformId', value: options.platformId });
    query.push({ key: 'type', value: options.type });
    query.push({ key: 'status', value: options.status });
    query.push({ key: 'pageFrom', value: options.pageFrom?.toString() });
    query.push({ key: 'pageSize', value: options.pageSize?.toString() });
    const queryString = query.filter((v: any) => !!v.value).map((v: any) => `${v.key}=${v.value}`).join('&');
    if (queryString) {
      url += `?${queryString}`;
    }
    const result = await Task.execute({ url, method: HttpMethod.GET });
    return result;
  }

  public static async approveByAccountant(pretensionId: number): Promise<TaskResponse> {
    const url = pretension.status.processAccountant;
    const result = await Task.execute({ url, method: HttpMethod.PUT, body: { pretensionId } });
    return result;
  }

  public static async approveBySigner(
    pretensionId: number,
    signerEmail: string,
    diadocSignerLogin: string,
    diadocSignerPassword: string,
  ): Promise<TaskResponse> {
    const url = pretension.status.processSigner;
    const payload = {
      pretensionId,
      signerEmail,
      diadocSignerLogin,
      diadocSignerPassword,
    };
    const result = await Task.execute({ url, method: HttpMethod.PUT, body: payload });
    return result;
  }

  public static async cancel(pretensionId: number): Promise<TaskResponse> {
    const url = pretension.status.cancel;
    const result = await Task.execute({ url, method: HttpMethod.PUT, body: { pretensionId } });
    return result;
  }

  public static async paymentDone(pretensionId: number): Promise<TaskResponse> {
    const url = pretension.status.paymentDone;
    const result = await Task.execute({ url, method: HttpMethod.PUT, body: { pretensionId } });
    return result;
  }
}

export default PretensionController;
